export const TESTING_DOMAINS = [
  '@tanantech.co.uk',
  '@lloydjames.com',
  '@yourclaimmatters.co.uk',
  '@mylawmatters.co.uk',
  '@legal-ventures.co.uk',
];

export const isTestingEmail = (email) => {
  if (!email) return false;
  const normalizedEmail = email.trim().toLowerCase();
  return TESTING_DOMAINS.some((domain) => normalizedEmail.endsWith(domain));
};
